module.exports = __webpack_public_path__ + "img/previous.f2fb9ec2.png";